// Textos da central de arquivos do DP (27/10/2026), coletados por glob em core/i18n/messages.ts.
export default {
  pt: {
    'dp.arquivos.titulo': 'Arquivos',
    'dp.arquivos.aba.upload': 'Upload',
    'dp.arquivos.aba.historico': 'Histórico',
    'dp.arquivos.enviar': 'Enviar arquivo',
    'dp.arquivos.reconhecendo': 'Reconhecendo',
    'dp.arquivos.solte': 'Solte para o Hub reconhecer o arquivo',
    'dp.arquivos.fechar': 'Fechar',
    'dp.arquivos.sistema': 'Sistema',
    'dp.arquivos.grupo.fornecedor': 'Fornecedores',
    'dp.arquivos.grupo.protheus': 'TOTVS / Protheus',
    'dp.arquivos.grupo.planilha': 'Planilhas do DP',
    'dp.arquivos.nome.hapvida': 'Hapvida',
    'dp.arquivos.nome.unimed': 'Unimed',
    'dp.arquivos.nome.ats': 'ATS',
    'dp.arquivos.nome.topdata': 'Topdata',
    'dp.arquivos.nome.dimep': 'Dimep Kairos',
    'dp.arquivos.nome.base_ativos': 'Base de ativos',
    'dp.arquivos.nome.ferias': 'Programação de férias',
    'dp.arquivos.nome.cnh': 'Vencimento da CNH',
    'dp.arquivos.nome.exames': 'Exames do mês',
    'dp.arquivos.nome.afastamentos': 'Afastamentos',
    'dp.arquivos.nome.ferias_calculadas': 'Férias calculadas',
    'dp.arquivos.nome.folha': 'Folha do mês',
    'dp.arquivos.nome.desligamentos': 'Fila de rescisões',
    'dp.arquivos.subtitulo.hapvida': 'Fatura e coparticipação',
    'dp.arquivos.subtitulo.unimed': 'Fatura e coparticipação',
    'dp.arquivos.subtitulo.ats': 'Assinaturas do ponto',
    'dp.arquivos.subtitulo.topdata': 'Ponto da matriz',
    'dp.arquivos.subtitulo.dimep': 'Ponto de Paracatu',
    'dp.arquivos.subtitulo.base_ativos': 'Colaboradores do Protheus',
    'dp.arquivos.subtitulo.ferias': 'Planejamento de férias',
    'dp.arquivos.subtitulo.cnh': 'Controle de habilitações',
    'dp.arquivos.subtitulo.exames': 'Exames ocupacionais',
    'dp.arquivos.subtitulo.afastamentos': 'Histórico de afastamentos',
    'dp.arquivos.subtitulo.ferias_calculadas': 'Férias pagas na folha',
    'dp.arquivos.subtitulo.folha': 'Verbas por pessoa',
    'dp.arquivos.subtitulo.desligamentos': 'Desligamentos em andamento',
    'dp.arquivos.marca.hapvida': 'Hapvida',
    'dp.arquivos.marca.unimed': 'Unimed',
    'dp.arquivos.marca.ats': 'ATS',
    'dp.arquivos.marca.topdata': 'Topdata',
    'dp.arquivos.marca.dimep': 'Dimep Kairos',
    'dp.arquivos.marca.base_ativos': 'TOTVS',
    'dp.arquivos.marca.ferias': 'TOTVS',
    'dp.arquivos.marca.cnh': 'TOTVS',
    'dp.arquivos.marca.exames': 'Exames',
    'dp.arquivos.marca.afastamentos': 'TOTVS',
    'dp.arquivos.marca.ferias_calculadas': 'TOTVS',
    'dp.arquivos.marca.folha': 'TOTVS',
    'dp.arquivos.marca.desligamentos': 'Desligamentos',
    'dp.arquivos.nome.rotinas': 'Descrição das atividades',
    'dp.arquivos.subtitulo.rotinas': 'Rotinas e checklist da folha',
    'dp.arquivos.marca.rotinas': 'Rotinas',
    'dp.arquivos.indisponivel.exemplo_unimed': 'O envio da Unimed ainda não está disponível. Falta um relatório de exemplo para o Hub aprender o formato.',
    'dp.arquivos.indisponivel.ponto_administrativo': 'O envio do ponto administrativo ainda não está disponível. Falta um arquivo de exemplo do relógio e a tela do ponto administrativo.',
    'dp.arquivos.importado': 'Arquivo importado: {{origem}}.',
    'dp.arquivos.verNoHistorico': 'Ver no histórico',
    'dp.arquivos.naoReconhecido': 'Não reconheci {{arquivo}}. Escolha a origem pelo cartão.',
    'dp.arquivos.relogio': '{{arquivo}} é um arquivo de relógio de ponto. O Hub ainda não lê o ponto administrativo.',
    'dp.arquivos.semPermissao': 'Reconheci {{arquivo}}, mas seu cargo não importa esse arquivo.',
    'dp.arquivos.jaImportado': '{{arquivo}} já entrou em {{data}} por {{quem}}. A prévia mostra o que muda.',
    'dp.arquivos.variasOrigens': 'Mande um arquivo por vez, ou os dois CSVs da mesma fatura juntos.',
    'dp.arquivos.mes': 'Mês',
    'dp.arquivos.todasOrigens': 'Todas as origens',
    'dp.arquivos.todosResultados': 'Todos os resultados',
    'dp.arquivos.resultado.sem_pendencias': 'Importado',
    'dp.arquivos.resultado.com_pendencias': 'Com pendências',
    'dp.arquivos.kpi.chegaram': 'Chegaram no mês',
    'dp.arquivos.kpi.chegaramDica': 'Origens com importação que já receberam arquivo neste mês.',
    'dp.arquivos.kpi.prazo': 'Prazo em aberto',
    'dp.arquivos.kpi.prazoDica': 'Ainda sem o arquivo do dia certo no cronograma do DP: {{origens}}.',
    'dp.arquivos.kpi.prazoNenhum': 'Todo arquivo com dia certo no cronograma do DP já chegou neste mês.',
    'dp.arquivos.kpi.pendencias': 'Envios com pendências',
    'dp.arquivos.col.quando': 'Data e hora',
    'dp.arquivos.col.origem': 'Origem',
    'dp.arquivos.col.arquivo': 'Arquivo',
    'dp.arquivos.col.quem': 'Usuário',
    'dp.arquivos.col.resultado': 'Resultado',
    'dp.arquivos.col.quantidades': 'Quantidades',
    'dp.arquivos.qtdNovas': '{{n}} novas',
    'dp.arquivos.qtdAtualizadas': '{{n}} atualizadas',
    'dp.arquivos.qtdPendentes': '{{n}} pendentes',
    'dp.arquivos.semEnvios': 'Nenhum arquivo enviado com estes filtros.',
    'dp.arquivos.detalhe.titulo': 'Envio',
    'dp.arquivos.detalhe.abrir': 'Ver detalhes',
    'dp.arquivos.detalhe.processamento': 'Processamento',
    'dp.arquivos.detalhe.abrirPendencias': 'Abrir pendências',
    'dp.arquivos.qtd.linhas': 'Linhas lidas',
    'dp.arquivos.qtd.gravadas': 'Novas',
    'dp.arquivos.qtd.atualizadas': 'Atualizadas',
    'dp.arquivos.qtd.ignoradas': 'Fora do escopo',
    'dp.arquivos.qtd.pendentes': 'Pendentes',
    'dp.arquivos.contagem': '{{gravadas}} novas e {{atualizadas}} atualizadas',
    'dp.arquivos.semPendencias': 'Sem pendências',
    'dp.arquivos.pendencia.hapvida': '{{n}} titulares sem a matrícula da folha.',
    'dp.arquivos.pendencia.exames': '{{n}} convocações sem a pessoa no Hub.',
    'dp.arquivos.pendencia.ats': '{{n}} linhas que o Hub não conseguiu ligar a uma pessoa.',
    'dp.arquivos.pendencia.cnh': '{{n}} linhas de pessoas fora do cadastro do Hub.',
    'dp.arquivos.pendencia.ferias': '{{n}} linhas para conferir.',
    'dp.arquivos.pendencia.base_ativos': '{{n}} linhas para conferir.',
    'dp.arquivos.pendencia.afastamentos': '{{n}} linhas para conferir.',
    'dp.arquivos.pendencia.ferias_calculadas': '{{n}} férias calculadas sem a data de pagamento.',
    'dp.arquivos.pendencia.desligamentos': '{{n}} linhas para conferir.',
    'dp.arquivos.base.importarTitulo': 'Importar a base de ativos',
    'dp.arquivos.base.importarExplica': 'A aba BaseAtivos Protheus da planilha de controle de ativos e rescisões. A planilha inteira passa do limite de 10 MB: salve só essa aba num arquivo novo. As outras telas usam o quadro para achar a pessoa pelo CPF.',
    'dp.arquivos.base.foraDaFilial': 'Fora das filiais do DP',
    'dp.arquivos.base.foraPelaCategoria': 'Autônomos e pró-labore, fora',
    'dp.arquivos.base.ausentes': 'No Hub e fora do arquivo',
    'dp.arquivos.base.ultimoMovimento': 'Último movimento',
    'dp.arquivos.afastamentos.importarTitulo': 'Importar os afastamentos',
    'dp.arquivos.afastamentos.importarExplica': 'A consulta de afastamentos do Protheus que o DP roda no Power Query, a SR8. Vale o histórico inteiro ou só os últimos meses: o que sumir do arquivo sai só dentro das datas que ele cobre.',
    'dp.arquivos.afastamentos.emAberto': 'Em aberto',
    'dp.arquivos.calculadas.importarTitulo': 'Importar as férias calculadas',
    'dp.arquivos.calculadas.importarExplica': 'A consulta de férias calculadas do Protheus que o DP roda no Power Query, a SRH. A data de pagamento fecha o prazo de pagar dois dias úteis antes do início, na tela de Férias.',
    'dp.arquivos.calculadas.semPagamento': 'Sem data de pagamento',
    'dp.arquivos.pendencia.folha': '{{n}} verbas sem o tipo 1, 2, 3 ou 4, fora do custo e das regras por tipo.',
    'dp.arquivos.folha.importarTitulo': 'Importar a folha do mês',
    'dp.arquivos.folha.importarExplica': 'A consulta da folha do Protheus que o DP roda no Power Query, a SRC para a folha em aberto e a SRD para a fechada. Mandar só um mês não apaga os outros. O arquivo de um mês cabe no limite de 10 MB.',
    'dp.arquivos.folha.periodos': 'Períodos no arquivo',
    'dp.arquivos.folha.pessoas': 'Pessoas',
    'dp.arquivos.folha.verbas': 'Verbas diferentes',
    'dp.arquivos.folha.proventos': 'Total de proventos',
    'dp.arquivos.folha.semTipo': 'Verbas sem tipo',
    'dp.arquivos.rescisoes.importarTitulo': 'Importar a fila de rescisões',
    'dp.arquivos.rescisoes.importarExplica': 'A aba Rescisoes da planilha de controle de ativos e rescisões. A planilha inteira passa do limite de 10 MB: salve só essa aba num arquivo novo. O caso já mexido no Hub não é sobrescrito, e o líquido e o FGTS só entram para quem vê dado sensível.',
    'dp.arquivos.rescisoes.semPessoa': 'Fora do cadastro do Hub',
    'dp.arquivos.encerrados': 'Saíram do arquivo',
  },
  en: {
    'dp.arquivos.titulo': 'Files',
    'dp.arquivos.aba.upload': 'Upload',
    'dp.arquivos.aba.historico': 'History',
    'dp.arquivos.enviar': 'Send file',
    'dp.arquivos.reconhecendo': 'Recognizing',
    'dp.arquivos.solte': 'Drop it so the Hub can recognize the file',
    'dp.arquivos.fechar': 'Close',
    'dp.arquivos.sistema': 'System',
    'dp.arquivos.grupo.fornecedor': 'Suppliers',
    'dp.arquivos.grupo.protheus': 'TOTVS / Protheus',
    'dp.arquivos.grupo.planilha': 'HR spreadsheets',
    'dp.arquivos.nome.hapvida': 'Hapvida',
    'dp.arquivos.nome.unimed': 'Unimed',
    'dp.arquivos.nome.ats': 'ATS',
    'dp.arquivos.nome.topdata': 'Topdata',
    'dp.arquivos.nome.dimep': 'Dimep Kairos',
    'dp.arquivos.nome.base_ativos': 'Active staff base',
    'dp.arquivos.nome.ferias': 'Vacation schedule',
    'dp.arquivos.nome.cnh': 'Driver license expiry',
    'dp.arquivos.nome.exames': 'Monthly exams',
    'dp.arquivos.nome.afastamentos': 'Leaves of absence',
    'dp.arquivos.nome.ferias_calculadas': 'Calculated vacations',
    'dp.arquivos.nome.folha': 'Monthly payroll',
    'dp.arquivos.nome.desligamentos': 'Termination queue',
    'dp.arquivos.subtitulo.hapvida': 'Invoice and copayment',
    'dp.arquivos.subtitulo.unimed': 'Invoice and copayment',
    'dp.arquivos.subtitulo.ats': 'Timesheet signatures',
    'dp.arquivos.subtitulo.topdata': 'Head office time clock',
    'dp.arquivos.subtitulo.dimep': 'Paracatu time clock',
    'dp.arquivos.subtitulo.base_ativos': 'Protheus employees',
    'dp.arquivos.subtitulo.ferias': 'Vacation planning',
    'dp.arquivos.subtitulo.cnh': 'Driver license control',
    'dp.arquivos.subtitulo.exames': 'Occupational exams',
    'dp.arquivos.subtitulo.afastamentos': 'Leave history',
    'dp.arquivos.subtitulo.ferias_calculadas': 'Vacations paid in payroll',
    'dp.arquivos.subtitulo.folha': 'Pay codes by person',
    'dp.arquivos.subtitulo.desligamentos': 'Terminations in progress',
    'dp.arquivos.marca.hapvida': 'Hapvida',
    'dp.arquivos.marca.unimed': 'Unimed',
    'dp.arquivos.marca.ats': 'ATS',
    'dp.arquivos.marca.topdata': 'Topdata',
    'dp.arquivos.marca.dimep': 'Dimep Kairos',
    'dp.arquivos.marca.base_ativos': 'TOTVS',
    'dp.arquivos.marca.ferias': 'TOTVS',
    'dp.arquivos.marca.cnh': 'TOTVS',
    'dp.arquivos.marca.exames': 'Exams',
    'dp.arquivos.marca.afastamentos': 'TOTVS',
    'dp.arquivos.marca.ferias_calculadas': 'TOTVS',
    'dp.arquivos.marca.folha': 'TOTVS',
    'dp.arquivos.marca.desligamentos': 'Terminations',
    'dp.arquivos.nome.rotinas': 'Activity description',
    'dp.arquivos.subtitulo.rotinas': 'Routines and payroll checklist',
    'dp.arquivos.marca.rotinas': 'Routines',
    'dp.arquivos.indisponivel.exemplo_unimed': 'Unimed uploads are not available yet. The Hub needs a sample report to learn the format.',
    'dp.arquivos.indisponivel.ponto_administrativo': 'Office time clock uploads are not available yet. The Hub needs a sample clock file and the office timekeeping screen.',
    'dp.arquivos.importado': 'File imported: {{origem}}.',
    'dp.arquivos.verNoHistorico': 'View in history',
    'dp.arquivos.naoReconhecido': 'I could not recognize {{arquivo}}. Choose the source from its card.',
    'dp.arquivos.relogio': '{{arquivo}} is a time clock file. The Hub does not read office timekeeping yet.',
    'dp.arquivos.semPermissao': 'I recognized {{arquivo}}, but your role does not import this file.',
    'dp.arquivos.jaImportado': '{{arquivo}} was imported on {{data}} by {{quem}}. The preview shows what changes.',
    'dp.arquivos.variasOrigens': 'Send one file at a time, or both CSVs of the same invoice together.',
    'dp.arquivos.mes': 'Month',
    'dp.arquivos.todasOrigens': 'All sources',
    'dp.arquivos.todosResultados': 'All results',
    'dp.arquivos.resultado.sem_pendencias': 'Imported',
    'dp.arquivos.resultado.com_pendencias': 'With pending items',
    'dp.arquivos.kpi.chegaram': 'Arrived this month',
    'dp.arquivos.kpi.chegaramDica': 'Sources with an import that already received a file this month.',
    'dp.arquivos.kpi.prazo': 'Open deadlines',
    'dp.arquivos.kpi.prazoDica': 'Still missing the file due on a fixed day of the HR schedule: {{origens}}.',
    'dp.arquivos.kpi.prazoNenhum': 'Every file with a fixed day in the HR schedule already arrived this month.',
    'dp.arquivos.kpi.pendencias': 'Uploads with pending items',
    'dp.arquivos.col.quando': 'Date and time',
    'dp.arquivos.col.origem': 'Source',
    'dp.arquivos.col.arquivo': 'File',
    'dp.arquivos.col.quem': 'User',
    'dp.arquivos.col.resultado': 'Result',
    'dp.arquivos.col.quantidades': 'Quantities',
    'dp.arquivos.qtdNovas': '{{n}} new',
    'dp.arquivos.qtdAtualizadas': '{{n}} updated',
    'dp.arquivos.qtdPendentes': '{{n}} pending',
    'dp.arquivos.semEnvios': 'No file sent with these filters.',
    'dp.arquivos.detalhe.titulo': 'Upload',
    'dp.arquivos.detalhe.abrir': 'View details',
    'dp.arquivos.detalhe.processamento': 'Processing',
    'dp.arquivos.detalhe.abrirPendencias': 'Open pending items',
    'dp.arquivos.qtd.linhas': 'Rows read',
    'dp.arquivos.qtd.gravadas': 'New',
    'dp.arquivos.qtd.atualizadas': 'Updated',
    'dp.arquivos.qtd.ignoradas': 'Out of scope',
    'dp.arquivos.qtd.pendentes': 'Pending',
    'dp.arquivos.contagem': '{{gravadas}} new and {{atualizadas}} updated',
    'dp.arquivos.semPendencias': 'No pending items',
    'dp.arquivos.pendencia.hapvida': '{{n}} holders without the payroll registration.',
    'dp.arquivos.pendencia.exames': '{{n}} exam calls without the person in the Hub.',
    'dp.arquivos.pendencia.ats': '{{n}} rows the Hub could not link to a person.',
    'dp.arquivos.pendencia.cnh': '{{n}} rows for people outside the Hub roster.',
    'dp.arquivos.pendencia.ferias': '{{n}} rows to review.',
    'dp.arquivos.pendencia.base_ativos': '{{n}} rows to review.',
    'dp.arquivos.pendencia.afastamentos': '{{n}} rows to review.',
    'dp.arquivos.pendencia.ferias_calculadas': '{{n}} calculated vacations without a payment date.',
    'dp.arquivos.pendencia.desligamentos': '{{n}} rows to review.',
    'dp.arquivos.base.importarTitulo': 'Import the active staff base',
    'dp.arquivos.base.importarExplica': 'The BaseAtivos Protheus sheet of the staff and terminations control. The whole spreadsheet is over the 10 MB limit: save only that sheet as a new file. The other screens use this roster to find people by CPF.',
    'dp.arquivos.base.foraDaFilial': 'Outside the HR branches',
    'dp.arquivos.base.foraPelaCategoria': 'Contractors and partners, left out',
    'dp.arquivos.base.ausentes': 'In the Hub and missing from the file',
    'dp.arquivos.base.ultimoMovimento': 'Last movement',
    'dp.arquivos.afastamentos.importarTitulo': 'Import leaves of absence',
    'dp.arquivos.afastamentos.importarExplica': 'The Protheus leave query the HR team runs in Power Query, table SR8. The whole history or only recent months both work: what disappears from the file leaves only within the dates it covers.',
    'dp.arquivos.afastamentos.emAberto': 'Open',
    'dp.arquivos.calculadas.importarTitulo': 'Import calculated vacations',
    'dp.arquivos.calculadas.importarExplica': 'The Protheus calculated vacation query the HR team runs in Power Query, table SRH. The payment date closes the deadline of paying two business days before the start, on the Vacations screen.',
    'dp.arquivos.calculadas.semPagamento': 'No payment date',
    'dp.arquivos.pendencia.folha': '{{n}} pay codes without type 1, 2, 3 or 4, out of the cost and the rules by type.',
    'dp.arquivos.folha.importarTitulo': 'Import the monthly payroll',
    'dp.arquivos.folha.importarExplica': 'The Protheus payroll query the HR team runs in Power Query, table SRC for the open payroll and SRD for the closed one. Sending one month does not erase the others. A one month file fits the 10 MB limit.',
    'dp.arquivos.folha.periodos': 'Periods in the file',
    'dp.arquivos.folha.pessoas': 'People',
    'dp.arquivos.folha.verbas': 'Different pay codes',
    'dp.arquivos.folha.proventos': 'Total earnings',
    'dp.arquivos.folha.semTipo': 'Pay codes without type',
    'dp.arquivos.rescisoes.importarTitulo': 'Import the termination queue',
    'dp.arquivos.rescisoes.importarExplica': 'The Rescisoes sheet of the staff and terminations spreadsheet. The whole spreadsheet exceeds the 10 MB limit: save only that sheet in a new file. A case already changed in the Hub is not overwritten, and net pay and FGTS only enter for whoever sees sensitive data.',
    'dp.arquivos.rescisoes.semPessoa': 'Not in the Hub records',
    'dp.arquivos.encerrados': 'Left the file',
  },
  es: {
    'dp.arquivos.titulo': 'Archivos',
    'dp.arquivos.aba.upload': 'Carga',
    'dp.arquivos.aba.historico': 'Historial',
    'dp.arquivos.enviar': 'Enviar archivo',
    'dp.arquivos.reconhecendo': 'Reconociendo',
    'dp.arquivos.solte': 'Suelte para que el Hub reconozca el archivo',
    'dp.arquivos.fechar': 'Cerrar',
    'dp.arquivos.sistema': 'Sistema',
    'dp.arquivos.grupo.fornecedor': 'Proveedores',
    'dp.arquivos.grupo.protheus': 'TOTVS / Protheus',
    'dp.arquivos.grupo.planilha': 'Planillas de RR. HH.',
    'dp.arquivos.nome.hapvida': 'Hapvida',
    'dp.arquivos.nome.unimed': 'Unimed',
    'dp.arquivos.nome.ats': 'ATS',
    'dp.arquivos.nome.topdata': 'Topdata',
    'dp.arquivos.nome.dimep': 'Dimep Kairos',
    'dp.arquivos.nome.base_ativos': 'Base de activos',
    'dp.arquivos.nome.ferias': 'Programación de vacaciones',
    'dp.arquivos.nome.cnh': 'Vencimiento de la licencia',
    'dp.arquivos.nome.exames': 'Exámenes del mes',
    'dp.arquivos.nome.afastamentos': 'Ausencias',
    'dp.arquivos.nome.ferias_calculadas': 'Vacaciones calculadas',
    'dp.arquivos.nome.folha': 'Nómina del mes',
    'dp.arquivos.nome.desligamentos': 'Fila de despidos',
    'dp.arquivos.subtitulo.hapvida': 'Factura y copago',
    'dp.arquivos.subtitulo.unimed': 'Factura y copago',
    'dp.arquivos.subtitulo.ats': 'Firmas del registro de jornada',
    'dp.arquivos.subtitulo.topdata': 'Reloj de la matriz',
    'dp.arquivos.subtitulo.dimep': 'Reloj de Paracatu',
    'dp.arquivos.subtitulo.base_ativos': 'Colaboradores de Protheus',
    'dp.arquivos.subtitulo.ferias': 'Planificación de vacaciones',
    'dp.arquivos.subtitulo.cnh': 'Control de licencias',
    'dp.arquivos.subtitulo.exames': 'Exámenes ocupacionales',
    'dp.arquivos.subtitulo.afastamentos': 'Historial de ausencias',
    'dp.arquivos.subtitulo.ferias_calculadas': 'Vacaciones pagadas en nómina',
    'dp.arquivos.subtitulo.folha': 'Conceptos por persona',
    'dp.arquivos.subtitulo.desligamentos': 'Despidos en curso',
    'dp.arquivos.marca.hapvida': 'Hapvida',
    'dp.arquivos.marca.unimed': 'Unimed',
    'dp.arquivos.marca.ats': 'ATS',
    'dp.arquivos.marca.topdata': 'Topdata',
    'dp.arquivos.marca.dimep': 'Dimep Kairos',
    'dp.arquivos.marca.base_ativos': 'TOTVS',
    'dp.arquivos.marca.ferias': 'TOTVS',
    'dp.arquivos.marca.cnh': 'TOTVS',
    'dp.arquivos.marca.exames': 'Exámenes',
    'dp.arquivos.marca.afastamentos': 'TOTVS',
    'dp.arquivos.marca.ferias_calculadas': 'TOTVS',
    'dp.arquivos.marca.folha': 'TOTVS',
    'dp.arquivos.marca.desligamentos': 'Despidos',
    'dp.arquivos.nome.rotinas': 'Descripción de las actividades',
    'dp.arquivos.subtitulo.rotinas': 'Rutinas y checklist de la nómina',
    'dp.arquivos.marca.rotinas': 'Rutinas',
    'dp.arquivos.indisponivel.exemplo_unimed': 'El envío de Unimed aún no está disponible. Falta un informe de ejemplo para que el Hub aprenda el formato.',
    'dp.arquivos.indisponivel.ponto_administrativo': 'El envío de la jornada administrativa aún no está disponible. Falta un archivo de ejemplo del reloj y la pantalla de jornada administrativa.',
    'dp.arquivos.importado': 'Archivo importado: {{origem}}.',
    'dp.arquivos.verNoHistorico': 'Ver en el historial',
    'dp.arquivos.naoReconhecido': 'No reconocí {{arquivo}}. Elija el origen en su tarjeta.',
    'dp.arquivos.relogio': '{{arquivo}} es un archivo de reloj de jornada. El Hub aún no lee la jornada administrativa.',
    'dp.arquivos.semPermissao': 'Reconocí {{arquivo}}, pero su cargo no importa este archivo.',
    'dp.arquivos.jaImportado': '{{arquivo}} ya entró el {{data}} por {{quem}}. La vista previa muestra lo que cambia.',
    'dp.arquivos.variasOrigens': 'Envíe un archivo por vez, o los dos CSV de la misma factura juntos.',
    'dp.arquivos.mes': 'Mes',
    'dp.arquivos.todasOrigens': 'Todos los orígenes',
    'dp.arquivos.todosResultados': 'Todos los resultados',
    'dp.arquivos.resultado.sem_pendencias': 'Importado',
    'dp.arquivos.resultado.com_pendencias': 'Con pendientes',
    'dp.arquivos.kpi.chegaram': 'Llegaron en el mes',
    'dp.arquivos.kpi.chegaramDica': 'Orígenes con importación que ya recibieron archivo este mes.',
    'dp.arquivos.kpi.prazo': 'Plazo abierto',
    'dp.arquivos.kpi.prazoDica': 'Aún sin el archivo del día fijo en el cronograma de RR. HH.: {{origens}}.',
    'dp.arquivos.kpi.prazoNenhum': 'Todo archivo con día fijo en el cronograma de RR. HH. ya llegó este mes.',
    'dp.arquivos.kpi.pendencias': 'Envíos con pendientes',
    'dp.arquivos.col.quando': 'Fecha y hora',
    'dp.arquivos.col.origem': 'Origen',
    'dp.arquivos.col.arquivo': 'Archivo',
    'dp.arquivos.col.quem': 'Usuario',
    'dp.arquivos.col.resultado': 'Resultado',
    'dp.arquivos.col.quantidades': 'Cantidades',
    'dp.arquivos.qtdNovas': '{{n}} nuevas',
    'dp.arquivos.qtdAtualizadas': '{{n}} actualizadas',
    'dp.arquivos.qtdPendentes': '{{n}} pendientes',
    'dp.arquivos.semEnvios': 'Ningún archivo enviado con estos filtros.',
    'dp.arquivos.detalhe.titulo': 'Envío',
    'dp.arquivos.detalhe.abrir': 'Ver detalles',
    'dp.arquivos.detalhe.processamento': 'Procesamiento',
    'dp.arquivos.detalhe.abrirPendencias': 'Abrir pendientes',
    'dp.arquivos.qtd.linhas': 'Filas leídas',
    'dp.arquivos.qtd.gravadas': 'Nuevas',
    'dp.arquivos.qtd.atualizadas': 'Actualizadas',
    'dp.arquivos.qtd.ignoradas': 'Fuera del alcance',
    'dp.arquivos.qtd.pendentes': 'Pendientes',
    'dp.arquivos.contagem': '{{gravadas}} nuevas y {{atualizadas}} actualizadas',
    'dp.arquivos.semPendencias': 'Sin pendientes',
    'dp.arquivos.pendencia.hapvida': '{{n}} titulares sin la matrícula de nómina.',
    'dp.arquivos.pendencia.exames': '{{n}} convocatorias sin la persona en el Hub.',
    'dp.arquivos.pendencia.ats': '{{n}} filas que el Hub no pudo vincular a una persona.',
    'dp.arquivos.pendencia.cnh': '{{n}} filas de personas fuera del registro del Hub.',
    'dp.arquivos.pendencia.ferias': '{{n}} filas para revisar.',
    'dp.arquivos.pendencia.base_ativos': '{{n}} filas para revisar.',
    'dp.arquivos.pendencia.afastamentos': '{{n}} filas para revisar.',
    'dp.arquivos.pendencia.ferias_calculadas': '{{n}} vacaciones calculadas sin fecha de pago.',
    'dp.arquivos.pendencia.desligamentos': '{{n}} filas para revisar.',
    'dp.arquivos.base.importarTitulo': 'Importar la base de activos',
    'dp.arquivos.base.importarExplica': 'La hoja BaseAtivos Protheus de la planilla de control de activos y rescisiones. La planilla entera supera el límite de 10 MB: guarde solo esa hoja en un archivo nuevo. Las otras pantallas usan este cuadro para encontrar a la persona por el CPF.',
    'dp.arquivos.base.foraDaFilial': 'Fuera de las sucursales de RR. HH.',
    'dp.arquivos.base.foraPelaCategoria': 'Autónomos y socios, fuera',
    'dp.arquivos.base.ausentes': 'En el Hub y fuera del archivo',
    'dp.arquivos.base.ultimoMovimento': 'Último movimiento',
    'dp.arquivos.afastamentos.importarTitulo': 'Importar las ausencias',
    'dp.arquivos.afastamentos.importarExplica': 'La consulta de ausencias de Protheus que el DP ejecuta en Power Query, tabla SR8. Sirve el historial completo o solo los últimos meses: lo que desaparece del archivo sale solo dentro de las fechas que cubre.',
    'dp.arquivos.afastamentos.emAberto': 'Abiertas',
    'dp.arquivos.calculadas.importarTitulo': 'Importar las vacaciones calculadas',
    'dp.arquivos.calculadas.importarExplica': 'La consulta de vacaciones calculadas de Protheus que el DP ejecuta en Power Query, tabla SRH. La fecha de pago cierra el plazo de pagar dos días hábiles antes del inicio, en la pantalla de Vacaciones.',
    'dp.arquivos.calculadas.semPagamento': 'Sin fecha de pago',
    'dp.arquivos.pendencia.folha': '{{n}} conceptos sin el tipo 1, 2, 3 o 4, fuera del costo y de las reglas por tipo.',
    'dp.arquivos.folha.importarTitulo': 'Importar la nómina del mes',
    'dp.arquivos.folha.importarExplica': 'La consulta de la nómina de Protheus que el DP ejecuta en Power Query, tabla SRC para la nómina abierta y SRD para la cerrada. Enviar un mes no borra los otros. El archivo de un mes cabe en el límite de 10 MB.',
    'dp.arquivos.folha.periodos': 'Períodos en el archivo',
    'dp.arquivos.folha.pessoas': 'Personas',
    'dp.arquivos.folha.verbas': 'Conceptos diferentes',
    'dp.arquivos.folha.proventos': 'Total de devengos',
    'dp.arquivos.folha.semTipo': 'Conceptos sin tipo',
    'dp.arquivos.rescisoes.importarTitulo': 'Importar la fila de despidos',
    'dp.arquivos.rescisoes.importarExplica': 'La hoja Rescisoes de la planilla de control de activos y despidos. La planilla completa supera el límite de 10 MB: guarde solo esa hoja en un archivo nuevo. El caso ya modificado en el Hub no se sobrescribe, y el líquido y el FGTS solo entran para quien ve datos sensibles.',
    'dp.arquivos.rescisoes.semPessoa': 'Fuera del registro del Hub',
    'dp.arquivos.encerrados': 'Salieron del archivo',
  },
}
